// @flow
import reducer from './src/auth'
export default reducer
